import React, { useMemo, useState, useCallback } from 'react';
import { useStandardCollator } from 'js/utils/string';
import { useParams } from 'react-router-dom';

import { Input, Card, CardBody } from 'reactstrap';
import { PanelHeader, Icon } from 'js/components';
import { Breadcrumbs } from 'js/components/Breadcrumbs';
import { TemplateStepHint } from 'js/components/Onboarding';
import RecommendedAssessments from './RecommendedAssessments';

import CreateAssessmentTemplate from 'js/components/Assessment/CreateAssessmentTemplate';

import { faSquare } from '@fortawesome/pro-solid-svg-icons';

import styles from './CreateAssessmentsComponent.module.scss';

function CreateAssessmentsComponent({
  templates,
  team,
  onCreateAssessment = () => {},
  productKey,
}) {
  const { workspaceId, teamId } = useParams();

  const breadcrumbs = useMemo(
    () => [
      {
        label: team?.name,
        to: `/w/${workspaceId}/teams/${teamId}/dashboard`,
      },
    ],
    [team?.name, workspaceId, teamId]
  );

  const collator = useStandardCollator();

  const [search, setSearch] = useState('');
  const filteredTemplates = useMemo(() => {
    const trimmedSearch = search.trim().toLowerCase();

    return templates
      .filter(
        (template) =>
          trimmedSearch === '' ||
          template.name.toLowerCase().includes(trimmedSearch) ||
          template.description.toLowerCase().includes(trimmedSearch)
      )
      .sort(
        (a, b) =>
          collator.compare(a.name, b.name) || collator.compare(a.id, b.id)
      );
  }, [templates, search, collator]);

  const handleSearch = useCallback((e) => {
    setSearch(e.target.value);
  }, []);

  const hasSearch = search.trim() !== '';

  return (
    <div className="survey-assessment create">
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <section className="details">
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <h1>Which assessment would you like to conduct?</h1>

            <p>Select from the choices below:</p>
            <TemplateStepHint />
          </section>
        </div>
        <div className="container-fluid">
          <div className={styles['search-bar']}>
            <div className={styles['template-legend']}>
              <div>
                <Icon icon={faSquare} className="icon-left" />
                Public
              </div>
              <div>
                <Icon icon={faSquare} className="text-info icon-left" />
                Private
              </div>
            </div>
            <div className={styles['search-input']}>
              <Input
                type="text"
                placeholder="Search templates"
                className="search-input limited-width-lg"
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
      </PanelHeader>
      <div className="content">
        {productKey && (
          <>
            {/* <Card>
          <CardHeader>
            <CardTitle tag="h3">
              Which assessment would you like to conduct?
            </CardTitle>
          </CardHeader>
          <CardBody>
            <p>Select from the choices below.</p>
          </CardBody>
        </Card> */}
            {!hasSearch && <RecommendedAssessments templates={templates} />}
            {filteredTemplates.map((template) => (
              <CreateAssessmentTemplate
                key={template.id}
                onSelect={onCreateAssessment.bind(null, template)}
                template={template}
              />
            ))}
            {filteredTemplates.length === 0 && search.trim() !== '' && (
              <Card>
                <CardBody>
                  <div className="media text-muted mt-4 mb-4">
                    <Icon
                      icon={['fal', 'spider-web']}
                      size="4x"
                      className="mr-3"
                      fixedWidth
                    />
                    <div className="media-body">
                      <p>There are no assessments that match your search.</p>
                      <p>
                        Try searching for a different term or browse the
                        available templates.
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default CreateAssessmentsComponent;
